import React from 'react';
import {NavLink} from "react-router-dom";
import {LOGIN_ROUTE} from "../../util/Constants";

const RegistrationForm = ({data, setData, authorize, handleEnterPress, invalid, oauthFooter}) => {
    return (
        <div className="w-full max-w-md rounded-3xl border border-stone-200/70 bg-white/95 p-8 shadow-soft backdrop-blur-sm">
            <h2 className="text-center text-2xl font-semibold tracking-tight text-bark-900">Регистрация</h2>
            {invalid ? (
                <p className="mt-3 rounded-2xl bg-red-50 px-3 py-2 text-center text-sm text-red-700">{invalid}</p>
            ) : null}
            <div className="mt-6 flex flex-col gap-4">
                <div>
                    <label className="lut-label">Email</label>
                    <input
                        className="lut-input"
                        placeholder="email"
                        value={data.email}
                        onChange={(e) => setData({...data, email: e.target.value})}
                        type="email"
                        onKeyUp={handleEnterPress}
                    />
                </div>
                <div>
                    <label className="lut-label">Пароль</label>
                    <input
                        className="lut-input"
                        placeholder="пароль"
                        value={data.password}
                        onChange={(e) => setData({...data, password: e.target.value})}
                        type="password"
                        onKeyUp={handleEnterPress}
                    />
                </div>
                <div>
                    <label className="lut-label">Подтверждение</label>
                    <input
                        className="lut-input"
                        placeholder="повторите пароль"
                        type="password"
                        value={data.passwordToCompare}
                        onChange={(e) => setData({...data, passwordToCompare: e.target.value})}
                        onKeyUp={handleEnterPress}
                    />
                </div>
                <div className="flex flex-col gap-3 pt-2 sm:flex-row sm:items-center sm:justify-between">
                    <button type="button" onClick={authorize} className="lut-btn-pine">
                        Зарегистрироваться
                    </button>
                    <span className="text-sm text-bark-600">
                        Есть аккаунт? <NavLink to={LOGIN_ROUTE} className="font-medium text-pine-700 hover:underline">Вход</NavLink>
                    </span>
                </div>
            </div>
            {oauthFooter}
        </div>
    );
};

export default RegistrationForm;
